import { ReturnTicketsViewModel } from "./return-tickets.vm";

export const ReturnTicketsInitialiser = () => {
  ko.applyBindings(new ReturnTicketsViewModel(), document.body);
}